import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';

import { useToastError } from 'lib/hooks/useToastError';
import { successToast } from 'lib/components/toasts/success';
import { conversationsKeys } from './queryKeys';
import { ISingleConversation } from './getSingleConversation';
import { EXPRESS_API } from 'configs/api/expressApi';

export interface IClosedResponse extends ISingleConversation {}

const markConversationAsClosed = async (
  conversationId: string
): Promise<IClosedResponse> => {
  return (await EXPRESS_API.patch(`conversations/${conversationId}/close`))
    .data as IClosedResponse;
};

export const useClosedConversationMutation = () => {
  const { showError } = useToastError();

  const queryClient = useQueryClient();
  const history = useHistory();

  return useMutation(markConversationAsClosed, {
    onError: (err: AxiosError) => showError(err),
    onSuccess: () => {
      successToast({ title: 'Your message is closed successfully' });
      queryClient.invalidateQueries(conversationsKeys.lists());
      history.replace({
        pathname: `/conversations`,
      });
    },
  });
};
